module.exports = __webpack_public_path__ + "3be4664ad21613ec37281333dbda6b6d.MP3";